import React from 'react';
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiActivity />,
        title: 'Staffing Services',
        link: 'service-details/1',
        description: 'Elevating your workforce by integrating exceptional talent, tailored to accelerate growth in value and reach unparalleled heights.'
    },
    {
        icon: <FiCast />,
        title: 'IT Services',
        link: '/service-details/3',
        description: 'Delivering tailor-made IT solutions that optimize performance, enhance security, and drive innovation for sustainable success.'
    },
    {
        icon: <FiMap />,
        title: 'Marketing Services',
        link: '/service-details/5',
        description: 'Crafting strategic, data-driven marketing campaigns that captivate audiences, boost brand visibility, and fuel sustainable growth.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to={val.link} dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;